import { render, staticRenderFns } from "./LoginForget.vue?vue&type=template&id=edf6673a&scoped=true&"
import script from "./LoginForget.vue?vue&type=script&lang=js&"
export * from "./LoginForget.vue?vue&type=script&lang=js&"
import style0 from "./LoginForget.vue?vue&type=style&index=0&id=edf6673a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf6673a",
  null
  
)

export default component.exports